import * as styledComponents from 'styled-components';
import merge from 'lodash/merge';
import {
  getDefaultConfigurationTheme,
  ThemeCode,
  TinkLinkThemeConfiguration,
} from '@tink/config/src/tinkLinkConfig';
import {
  theme as defaultTinkTheme,
  TinkTheme,
} from '@tink/core/src/components/providers/ThemeProvider/theme';

export interface TinkLinkTheme extends TinkTheme {
  configuration: TinkLinkThemeConfiguration;
}

export const tinkLinkTheme: TinkLinkTheme = merge(
  {
    configuration: {
      ...getDefaultConfigurationTheme(ThemeCode.LIGHT).colors,
      buttons: getDefaultConfigurationTheme(ThemeCode.LIGHT).buttons,
      header: getDefaultConfigurationTheme(ThemeCode.LIGHT).header,
      textAlignment: getDefaultConfigurationTheme(ThemeCode.LIGHT).textAlignment,
    },
  },
  defaultTinkTheme
);

const {
  default: styled,
  css,
  createGlobalStyle,
} = styledComponents as unknown as styledComponents.ThemedStyledComponentsModule<TinkLinkTheme>;

export { styled, css, createGlobalStyle };
